export default {
	// insititution 등록 , 수정시 사용하는 메소드
	methods: {
		// 유효성 검사
		validateAgencyCode: function() {
			const { agencyCode } = this.agency;

			if( !agencyCode ) {
				this.$emit("alert", "기관코드를 입력해주세요.");
				return false;
			}

			return true;
		},
		validateAgencyName: function() {
			const { agencyName } = this.agency;

			if( !agencyName ) {
				this.$emit("alert", "기관명을 입력해주세요.");
				return false;
			}

			return true;
		},
		validateAgencyAddr: function() {
			const { agencyAddr } = this.agency;

			if( !agencyAddr ) {
				this.$emit("alert", "기관 주소를 입력해주세요.");
				return false;
			}

			return true;
		}
	}
}